<template>
        <div>
          <div class="custom-loader-wrapper for-employee-page" v-if="payslip_loader">
            <div class="text-center">
                <span class="d-block max-450">{{payslip_loader_text}}</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
        </div>
	        <form @submit="formSubmit" enctype="multipart/form-data">
            <input class="input" type="hidden" v-model="fdata.id" >
			<input class="input" type="hidden" v-model="employee_id" >
			<input class="input" type="hidden" v-model="fiscal_year" >
			<input class="input" type="hidden" v-model="from_date" >
			<input class="input" type="hidden" v-model="to_date" >
			<input class="input" type="hidden" v-model="pay_slip_ref" >
			<input class="input" type="hidden" v-model="pay_slip_name" >
            <div class="row">
			  <div class="col-md-12 text-center"><p style="font-weight: bold; font-size: larger;margin-bottom: 0;">{{company_name}}</p><p><span style="font-weight: bold;">{{card_title}}</span><br />Income Year {{fiscal_year}}</p></div>
			</div>

      <div class="row">
        <div class="col-md-12">
            <table class="table table-bordered table-hover table-sm">

              <template v-for="(row, index) in dynamic_fields">
                <tr v-if="index == 0">
                  <td :key="index" style="text-align: left; font-size: 11pt; width:22%;"><strong>{{row.header_left_name}}</strong></td>  <td style="text-align: left; font-size: 11pt; width:30%;" ><strong v-if="row.header_left_name !='Month'">{{row.header_left_value}}</strong><strong v-else>{{pmonth+' '+pyear}}</strong></td>
                  <td style="text-align: left; font-size: 11pt; width:20%;"><strong>{{row.header_right_name}}</strong></td>  <td style="text-align: left; font-size: 11pt; width:30%;"  ><strong v-if="row.header_right_name !='Month'">{{row.header_right_value}}</strong><strong v-else>{{pmonth+' '+pyear}}</strong></td>
                </tr>
                <tr v-else>
                  <td :key="index" style="text-align: left; font-size: 11pt; width:22%;">{{row.header_left_name}}</td>  <td style="text-align: left; font-size: 11pt; width:30%;" ><template  v-if="row.header_left_name !='Month'">{{row.header_left_value}}</template><template v-else>{{pmonth+' '+pyear}}</template></td>
                  <td style="text-align: left; font-size: 11pt;width:20%;">{{row.header_right_name}}</td>  <td style="text-align: left; font-size: 11pt; width:30%;"><template  v-if="row.header_right_name != 'Month'">{{row.header_right_value}}</template><template v-else>{{pmonth+' '+pyear}}</template></td>
                </tr>
              </template>
            </table>
        </div>
      </div>


			<div class="row">
			  <div class="col-md-12">
                <h6 class="text-center font-weight-bold">Income Details</h6>
			    <table class="table">
			       <tbody>
			            <tr class="table-head table-head-center" style="font-weight: bold; text-align: left;"><td>Heads of Income</td><td>{{fdata.month}} {{fdata.year}}</td><td>YTD (up to previous month)</td><td>Projected Annual</td><td>Tax Exempt Income</td><td>Taxable Income</td></tr>

			            <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1'">
			              <template v-if="salaryhead.field_key != 'basic_salary_before_pregross' && salaryhead.field_key != 'house_rent_before_pregross' && salaryhead.field_key != 'conveyance_allowance_before_pregross' && salaryhead.field_key != 'medical_allowance_before_pregross'">
                          <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                          {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          <div>
                           ({{salaryhead.exemption}})
                          </div>

                          </td>


                        <td style="text-align: right;">
                        <div>
                        {{salaryhead.taxable}}
                        </div>
                        </td>
                        </template>

			            </tr>





                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.1' && !(salaryhead.taxable=='0' && salaryhead.value=='0' && salaryhead.ytd=='0')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                          {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          <div>
                        ({{salaryhead.exemption}})
                         </div>

                          </td>


                        <td style="text-align: right;">

                        <div>
                        {{salaryhead.taxable}}
                        </div>

                        </td>

			            </tr>


                        <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1.2' && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                          {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          <div>
                        ({{salaryhead.exemption}})
                         </div>

                          </td>


                        <td style="text-align: right;">

                        <div>
                        {{salaryhead.taxable}}
                        </div>

                        </td>

			            </tr>






                       <!-- Off cycle starts --->
                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Basic Salary'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>


                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear HRA'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
			              <td>Arrear House Rent Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>

                        <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Conveyance'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
			              <td>Arrear Conveyance Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>

                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear Medical'  && !(salaryhead.value=='0' && salaryhead.ytd=='0' && salaryhead.exemption=='0' && salaryhead.annual=='0' && salaryhead.taxable=='0')">
			              <td>Arrear Medical Allowance</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>



                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Arrear PF Employer\'s Contribution'  && !(salaryhead.value=='0' && salaryhead.taxable=='0')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>



                       <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'off_cycle_adhocs'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                           {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>

                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>


                        <td style="text-align: right;">
                          {{salaryhead.taxable}}
                        </td>

			            </tr>


						<tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
			              <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                          <td style="text-align: right;">
                          {{salaryhead.ytd}}
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.annual}}
                          </td>
                          <td style="text-align: right;">
                          ({{salaryhead.exemption}})
                          </td>

                          <td style="text-align: right;">
                          {{salaryhead.taxable}}
                          </td>
			            </tr>

                  <!--<tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'bonus_and_incentives'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
			              <td>{{salaryhead.head}}</td>
                    <td style="text-align: right;">{{salaryhead.value}}</td>
                    <td style="text-align: right;">{{salaryhead.ytd}}</td>
                    <td style="text-align: right;">{{salaryhead.annual}}</td>
                    <td style="text-align: right;">({{salaryhead.exemption}})</td>
                    <td style="text-align: right;">{{salaryhead.taxable}}</td>
			            </tr>-->

                  <!---------------------- Adding Overtime Bonus Data ---------------------->

                  <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="(salaryhead.displayset == 'overtime_holiday_manual' || salaryhead.displayset == 'overtime_holiday_incremental_days' || salaryhead.displayset == 'overtime_holiday_fixed' || salaryhead.displayset == 'overtime_holiday_incremental_hours') && !(salaryhead.taxable=='0' && salaryhead.value=='0')">
			                <td>{{salaryhead.head}}</td><td style="text-align: right;">{{salaryhead.value}}</td>
                      <td style="text-align: right;">
                        {{salaryhead.ytd}}
                      </td>
                      <td style="text-align: right;">
                        {{salaryhead.annual}}
                      </td>
                      <td style="text-align: right;">
                        <div>
                          ({{salaryhead.exemption}})
                        </div>
                      </td>
                      <td style="text-align: right;">
                        <div>
                          {{salaryhead.taxable}}
                        </div>
                      </td>

			            </tr>

                  <!---------------------- Adding Contracted Variable Data ---------------------->

                  <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'contracted_variable'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
			              <td>{{salaryhead.head}}</td>
                    <td style="text-align: right;">{{salaryhead.value}}</td>
                    <td style="text-align: right;">
                      {{salaryhead.ytd}}
                    </td>

                    <td style="text-align: right;">
                    {{salaryhead.annual}}
                    </td>

                    <td style="text-align: right;">
                    ({{salaryhead.exemption}})
                    </td>


                    <td style="text-align: right;">
                      {{salaryhead.taxable}}
                    </td>

			            </tr>

                  <!---------------------- Adding Manual Leave Encashment Data ---------------------->

                  <tr class="table-row hover-bg" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'manual_leave_encashment'  && (salaryhead.taxable!='0' && salaryhead.taxable!='0.00')">
			              <td>{{salaryhead.head}}</td>
                    <td style="text-align: right;">{{salaryhead.value}}</td>
                    <td style="text-align: right;">
                      {{salaryhead.ytd}}
                    </td>

                    <td style="text-align: right;">
                    {{salaryhead.annual}}
                    </td>

                    <td style="text-align: right;">
                    ({{salaryhead.exemption}})
                    </td>


                    <td style="text-align: right;">
                      {{salaryhead.taxable}}
                    </td>

			            </tr>

			            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'total_taxable'" class="s-tfoot" style="font-weight: bold;">
			            <td>Total</td><td style="text-align: right;">{{salaryhead.value}}</td>
                        <td style="text-align: right;">
                        {{salaryhead.ytd}}
                        </td>

                        <td style="text-align: right;">
                        {{salaryhead.annual}}
                        </td>

                        <td style="text-align: right;">
                        ({{salaryhead.exemption}})
                        </td>

                        <td style="text-align: right;">
                        {{salaryhead.taxable}}
                        </td>

			            </tr>
			       </tbody>
			      </table>
			   </div>
		 </div>
	     <div class="row  mt-2">
			  <div class="col-md-12">
                <h6 class="text-center font-weight-bold">Calculation of Income Tax Liability</h6>
			    <table class="table">
			       <tbody>
			            <tr class="table-head table-head-center" style="font-weight: bold;"><td>Slab</td><td>Taxable Income</td> <td>Tax Rate</td> <td>Tax Amount</td></tr>
			            <tr class="table-row hover-bg" v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '3'">
			              <td>{{slabsnvalue.head}}</td><td style="text-align: right;">{{slabsnvalue.slab}}</td><td style="text-align: center;">{{slabsnvalue.tax_rate}}</td><td style="text-align: right;">{{slabsnvalue.tax_amount}}</td>
			            </tr>
						<tr v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '300'" class="s-tfoot" style="font-weight: bold;">
			              <td>{{slabsnvalue.head}}</td><td style="text-align: right;">{{slabsnvalue.slab}}</td><td style="text-align: center;">{{slabsnvalue.tax_rate}}</td><td style="text-align: right;">{{slabsnvalue.tax_amount}}</td>
			            </tr>
			       </tbody>
			      </table>
			   </div>
		  </div>

          <div class="row mt-2" v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.head == 'On the balance Tk.' && slabsnvalue.residency!='no'">
			  <div class="col-md-12">
                <h6 class="text-center font-weight-bold">Calculation of Eligible Investment Amount</h6>
			    <table class="table">
			       <tbody>
			            <tr class="table-head table-head-center" style="font-weight: bold;"><td>#</td><td>Details</td><td>Amount</td><td>Eligible Amount</td></tr>
                  <tr class="table-row hover-bg" style="font-style: italic; font-weight: bold;"><td colspan="4">Lower of:</td></tr>
			            <tr class="table-row hover-bg" v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head=='Max Allow Inv Limit'">
		                  <td>a)</td><td>Maximum Investment Rebate <span style="font-style: italic;">(<span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Investment Rebate Percentage'">{{convertToInt(salaryhead.value)}}</span>% of total taxable income)</span></td> <td style="text-align: right;">{{taxhead.value}}</td><td class="text-right align-middle" rowspan="3">{{lower_of_amount}}</td>
		               </tr>

                        <tr class="table-row hover-bg" v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head=='Invested Amount'">
		                  <td>b)</td><td>Actual Investment Assumed</td> <td style="text-align: right;">{{taxhead.value}}</td>
		               </tr>
                   <tr class="table-row hover-bg" v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head=='Invested Amount'">
		                  <td>c)</td><td>Maximum Allowable Limit <span style="font-style: italic;">(as per prevailing regulations)</span></td> <td style="text-align: right;"><template v-if="decimal_setting == 'no'">10,000,000</template><template v-else>10,000,000.00</template></td>
		               </tr>


			       </tbody>
			      </table>
			   </div>
		  </div>

          <div class="row mt-2" v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.head == 'On the balance Tk.' && slabsnvalue.residency!='no'">
			  <div class="col-md-12">
                <h6 class="text-center font-weight-bold">Calculation of Tax Credit on Investment</h6>
			    <table class="table" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Investment Rebate Settings'  && salaryhead.investment_rebate_type == '1'">
			       <tbody>
			            <tr class="table-head table-head-center" style="font-weight: bold;"><td>#</td><td>Condition</td><td class="text-center">% of Credit Credit</td><td class="text-center">Credit Amount</td></tr>
			            <tr class="table-row hover-bg">
		                  <td>a)</td><td>If the total income does not exceed Tk. {{salaryhead.max_rebate_slab_1}}</td> <td>15% of the eligible amount</td><td v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head=='Investment Rebate'" rowspan="2" class="text-center align-middle">({{taxhead.value}})</td>
		               </tr>
                       <tr class="table-row hover-bg">
		                  <td>b)</td><td>If the total income exceeds Tk. {{salaryhead.max_rebate_slab_1}}</td><td>10% of the eligible amount</td>
		               </tr>


			       </tbody>
			      </table>
                  <table class="table" v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Investment Rebate Settings'  && salaryhead.investment_rebate_type == '0'">
			       <tbody>
			            <tr class="table-head table-head-center" style="font-weight: bold;"><td class="text-center">% of Credit Credit</td><td class="text-center">Credit Amount</td></tr>
			            <tr class="table-row hover-bg">
		                  <td>15% of the eligible amount</td><td v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head=='Investment Rebate'" class="text-center align-middle">({{taxhead.value}})</td>
		               </tr>


			       </tbody>
			      </table>
			   </div>
		  </div>

	     <div class="row mt-2">
		  <div class="col-md-12">
            <h6 class="text-center font-weight-bold">Income Tax Payable</h6>
		    <table class="table">
		       <tbody>
		              <tr class="table-head table-head-center"><td>Details</td><td class="w-25">&nbsp;</td><td class="text-center">Amount</td></tr>
                      <tr style="font-weight: bold;"><td>Total Income Tax Payable</td><td class="w-25">&nbsp;</td><td style="text-align: right;">{{taxdata['tax_total']}}</td></tr>
                      <tr class="table-row hover-bg" style="font-weight: bold; font-style: italic;"><td>Tax Paid Till Date:</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                      <tr class="table-row hover-bg"><td class="pl-5">Monthly Tax Deduction - YTD</td>
                      <td style="text-align: right;">

                        <div v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'Monthly tax paid till date'">
                         <template>
                         <!--<headytd  :employee_id="employee_id" :fiscal_year="fiscal_year" :head="'Monthely Tax Deduct'" :current_headvalue="taxdata['monthly_tax_deduct']" :month="fdata.month" :payslip_id="fdata.id"></headytd>-->
                         {{taxhead.value}}
                         </template>
                      </div>

                      </td>
                      <td>&nbsp;</td>
                      <tr class="table-row hover-bg"><td class="pl-5">One-off Tax Deduction - YTD</td><td style="text-align: right;">
                        <div v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'One-off tax paid till date'">
                          <template>
                          <!--<headytd  :employee_id="employee_id" :fiscal_year="fiscal_year" :head="'One-off Tax Deduct'" :current_headvalue="taxdata['one_of_tax_deduct']" :month="fdata.month" :payslip_id="fdata.id"></headytd>-->
                          {{taxhead.value}}
                          </template>
                        </div>
                      </td><td>&nbsp;</td></tr>

                      <tr class="table-row hover-bg"><td class="pl-5">AIT Adjustment - YTD</td><td style="text-align: right;">

                      <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Decleared AIT'">
                      {{salaryhead.value}}
                      </span>

                      </td><td>&nbsp;</td></tr>
                      <tr style="font-weight: bold;"><td colspan="2">Total tax paid till date</td><td class="text-right"><span v-for="taxhead in taxinfo" :key="taxhead.head" v-if="taxhead.head == 'Total tax paid till date'">{{taxhead.value}}</span></td></tr>
                      <tr class="table-row hover-bg">
                      <td>Remaining Tax Liability</td><td>&nbsp;</td>
                      <td style="text-align: right;">
                      <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Remaining Tax Payable'">
                      {{salaryhead.value}}
                      </span>
                      </td>
                      </tr>
                      <tr class="table-row hover-bg"><td>Remaining Months</td><td>&nbsp;</td>
                      <td style="text-align: right;">
                       <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Remaining Months'">
                      {{salaryhead.value}}
                      </span>
                      </td>
                      </tr>
                      <tr style="font-weight: bold; font-style: italic;"><td colspan="3">Tax deduction in {{fdata.month}} {{fdata.year}}</td></tr>
                      <tr class="table-row hover-bg"><td  class="pl-5">One-off Tax Deduction for {{fdata.month}} {{fdata.year}}</td><td style="text-align: right;">{{taxdata['one_of_tax_deduct']}}</td><td>&nbsp;</td></tr>
                      <tr class="table-row hover-bg"><td  class="pl-5">Monthly Tax Deduction for {{fdata.month}} {{fdata.year}} <span v-if="tax_allocation_method == 2"> *</span></td><td style="text-align: right;">{{taxdata['monthly_tax_deduct']}}</td><td>&nbsp;</td></tr>
                      <!--<tr><td>AIT Adjustment for {{fdata.month}} {{fdata.year}}</td><td>&nbsp;</td><td><span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'AIT Adjustment'">
                      {{salaryhead.value}}
                      </span></td></tr>-->
                      <tr class="table-row hover-bg" style="font-weight: bold;"><td>Total Tax Deduction for {{fdata.month}} {{fdata.year}}</td><td>&nbsp;</td><td style="text-align: right;">{{taxdata['total_tax_deduct']}}</td></tr>
		       </tbody>
		      </table>
		   </div>
	      </div>
          <div class="row mt-2">
			  <div class="col-md-12">
              <h6 class="font-weight-bold">Notes</h6>
              <ul class="list-unstyled p-0 m-0">
                <li>- <span style="font-weight: bold;">House Rent Allowance</span> is exempt up to Tk. <template v-if="decimal_setting == 'no'">25,000</template><template v-else>25,000.00</template> per month or 50% of Basic Salary, whichever is lower.</li>
                <li>- <span style="font-weight: bold;">Conveyance Allowance</span> of up to Tk. <template v-if="decimal_setting == 'no'">30,000</template><template v-else>30,000.00</template> per annum is exempt from tax.</li>
                <li>- <span style="font-weight: bold;">Medical Allowance</span> of up to Tk. <template v-if="decimal_setting == 'no'">120,000</template><template v-else>120,000.00</template> per annum or 10% of Basic Salary, whichever is lower is exempt from tax.</li>
                <li>- If an individual enjoys <span style="font-weight: bold;">Rent Free Accommodation</span> from employer, actual rent paid by employer or 25% of Basic Salary whichever is lower is added to total income and taxed.</li>
                <li>- If an individual enjoys <span style="font-weight: bold;">Conveyance for personal or private use</span> from employer, 5% of Basic Salary or Tk. <template v-if="decimal_setting == 'no'">60,000</template><template v-else>60,000.00</template> whichever is higher is added to total income and taxed.</li>
                <li>- <span style="font-weight: bold;">Maximum Allowable Investment Rebate Limit</span> is the lower of Actual Investment, <span v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.head == 'Investment Rebate Percentage'">{{convertToInt(salaryhead.value)}}</span>% of Total Taxable Income or Tk. <template v-if="decimal_setting == 'no'">10,000,000</template><template v-else>10,000,000.00</template>.</li>
                <li>- <span style="font-weight: bold;">Tax is allocated as per the following logic: </span><template v-if="tax_allocation_method == 1"> Spread Tax Equally over the Fiscal Year </template> <template v-else>Spread Tax as per Monthly Income (PAYE)</template></li>
              </ul>
              </div>
           </div>
           <div class="row mt-2">
              <div class="col-md-3 text-right"></div>
              <div class="col-md-4 text-right"><img v-if="action_loader" :src="$api_url+'/images/download-loader.gif'" class="w-25"/></div>
			  <div class="col-md-5">
              <!--<b-overlay :show="action_loader" rounded="sm">-->
                  <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="emailTaxCards(taxcard)" v-if="$acl['modifypayslips'] == 2"><i class="far fa-envelope px-1" aria-hidden="true" style="font-size:16px;"></i> Email</b-button>
                  <b-button class="border rounded bg-light float-right py-1 px-2 mt-4 ml-2" type="submit" variant="primary" @click="downloadTaxCards(taxcard,fiscal_year)" v-if="$acl['downloadtaxcards'] == 2"><i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;"></i> Download PDF</b-button>
              <!--</b-overlay>-->
              </div>
           </div>
           </form>
           <iframe id="pdf-frame" style="display: none;"></iframe>
        </div>
</template>
<style scoped>
.s-thead{background: #c9c9c9;}
.s-tfoot{background: #e5e5e5;}
</style>

  <script>

	  export default {
		  mounted() {
			 // console.log('Payslip started..');
			 // console.log(this.componentdata);
		  },
		  props: [ 'taxcard','company','cardname','emp_etin','emp_department','emp_jobposition','emp_code','emp_joining','emp_branch','emp_gender','emp_birth_date','emp_residency','pmonth','pyear','dynamic_fields'],


		  data() {

			  return {
			      employees : [],
			      salaryheads : [],
				  taxinfo : [],
                  taxdata : [],
				  fiscalyears: [],
				  adhocfields: [],
				  adhocheadsnvalues: [],
				  slabs_and_values : [],
				  fdata: [],

                  company_name:this.company,
                  card_title: this.cardname,
                  download_file_name: '',
				  success: '',
				  employee_id: '',
				  fiscal_year: '',
				  from_date: '',
				  to_date: '',
				  pay_slip_ref: '',
				  pay_slip_name: '',
				  month: '',
				  year: '',
				  adhoc_field: '',
				  adhoc_field_value: '',
          action_loader: false,

          lower_of_amount: 0,

          payslipids: [],

          decimal_setting: 'yes',

          payslip_loader_text: 'We are preparing the data for this employee.',
          payslip_loader : false,
          tax_allocation_method : 1,


			  }
		  },

		  methods:{
		      convertToInt: function(number)
			  {
				if(number){
				    number = parseInt(number);
				}
                return number;
			  },
			  setSearch: function(pageflg)
			  {
				this.getSalaryinfo();
			  },
			  getFiscalyears: function()
			  {

						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.fiscalyears = response.data;


				  }.bind(this));
			  },

              setTaxData: function(tax_info){

                for (var t_id in tax_info) {
                //console.log(tax_info[t_id]['head']);
                //this.child_component_values[f_key][f_id].is_checked = response.data.data[f_key][f_id].is_checked;
                if(tax_info[t_id]['head'] =='Tax Payable')
                this.taxdata['tax_total'] = tax_info[t_id]['value'];

                if(tax_info[t_id]['head'] =='Monthely Tax Deduct')
                this.taxdata['monthly_tax_deduct'] = tax_info[t_id]['value'];

                if(tax_info[t_id]['head'] =='AIT Adjusted Total Tax')   //if(tax_info[t_id]['head'] =='Total Tax Deduct')
                this.taxdata['total_tax_deduct'] = tax_info[t_id]['value'];

                if(tax_info[t_id]['head'] =='One-off Tax Deduct')
                this.taxdata['one_of_tax_deduct'] = tax_info[t_id]['value'];

                if(tax_info[t_id]['head'] =='Off-cycle Tax')
                this.taxdata['off_cycle_tax_deduct'] = tax_info[t_id]['value'];

                }
              },

              getSalaryinfo: function()
			  {
          this.payslip_loader = true;
						  axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
							  params: {
								  fiscal_year: this.fiscal_year,
								  payslip_id: this.fdata.id,
                                  output_type: 'merge_report',
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.salaryheads = response.data.salary;
					  this.slabs_and_values=response.data.slabsnvalues;
					  this.taxinfo=response.data.tax;
                      let max_inv_limit = 0;
                      let invested_amount = 0;

                      for (let [key, value] of Object.entries(this.taxinfo))
                      {
                        if(value.head === 'Invested Amount'){
                            invested_amount = value.value;
                        }
                        if(value.head === 'Max Allow Inv Limit'){
                            max_inv_limit = value.value;
                        }
                      }
                      if(parseFloat(max_inv_limit.replace(/,/g, '')) < parseFloat(invested_amount.replace(/,/g, '')))
                        this.lower_of_amount = max_inv_limit;
                      else
                        this.lower_of_amount = invested_amount;

                      if(parseFloat(this.lower_of_amount.replace(/,/g, '')) > 10000000)
                        this.lower_of_amount = 10000000;


					  this.adhocfields=response.data.adhocfields;
					  this.adhocheadsnvalues=response.data.adhocheadsnvalues;
                      this.setTaxData(response.data.tax);
                      this.payslip_loader = false;
				  }.bind(this));
			  },
             getPayslipInfo: function()
             {

                   axios.get(this.$api_url+'/payslipinfo/'+this.taxcard, {
                            params: {
                            }
                    }).then(function(response){
                    this.fdata = response.data.data;
                    this.employee_id = this.fdata.employee_id;
                    if(this.fdata.id!='')
            		  {
            		   this.fiscal_year=this.fdata.fiscal_year;
            		   this.employee_id=this.fdata.employee_id;
            		   this.from_date=this.fdata.from_date;
            		   this.to_date=this.fdata.to_date;
            		   this.pay_slip_ref=this.fdata.pay_slip_ref;

            		   //this.setSearch();
                   this.getSalaryDataFromDB('yes');
            		   this.pay_slip_name=this.fdata.pay_slip_name;

            		  }
                }.bind(this));
             },


            download_file(fileURL, fileName) {
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
        	       if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
        				document.location = save.href;
        			}else{
        		        var evt = new MouseEvent('click', {
        		            'view': window,
        		            'bubbles': true,
        		            'cancelable': false
        		        });
        		        save.dispatchEvent(evt);
        		        (window.URL || window.webkitURL).revokeObjectURL(save.href);
        			}
            }
            else if ( !! window.ActiveXObject && document.execCommand)     {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
           },

           downloadTaxCards: function(tx_card,f_year,email_file=false,prnt_file=false)
			  {
				     this.action_loader = true;
                     var send_file = email_file ? 1: 0;
                     axios.get(this.$api_url+'/taxcardpdf/'+f_year+'/'+tx_card , {
							  params: {
							     em_file:  send_file
							  },
                          headers: { 'Content-Type': 'application/json; charset=utf-8', },
                          responseType: 'blob',
					  }).then(function(response){

                      this.action_loader = false;


					  if(response.data){

                      if(response.data.download_name)
                      this.download_file_name = response.data.download_name;
                      else
                      this.download_file_name = this.card_title;

                      if(prnt_file){
                        // this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                        if(response.data.type =='application/json'){
                                    let file = new Blob([response.data], {type: 'application/json'});
                                    const cast = Promise.resolve(file.text());
                                    cast.then((value) => {
                                        let err_obj = JSON.parse(`${value}`);
                                        this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                    });
                                }else{
                                    this.global_download_file_content(response);
                                }
                      }
                      else if(email_file){
                        if(response.data.success)
                        this.$bvToast.toast(response.data.success, {
                                           title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                        else if(response.data.error)
                        this.$bvToast.toast(response.data.error, {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }
                      else{
                      // this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                      if(response.data.type =='application/json'){
                                    let file = new Blob([response.data], {type: 'application/json'});
                                    const cast = Promise.resolve(file.text());
                                    cast.then((value) => {
                                        let err_obj = JSON.parse(`${value}`);
                                        this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                    });
                                }else{
                                    this.global_download_file_content(response);
                                }
                      }
                      }
                      else if(response.data.error){
                        this.$bvToast.toast(response.data.error, {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }else{
                        this.$bvToast.toast('Unexpected server error!', {
                                           title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });
                      }
                      //console.log(response.data.file_name);
				  }.bind(this));
		     },
             formSubmit(e) {
				  e.preventDefault();
				  let currentObj = this;
                  const config = {
					  headers: { 'content-type': 'multipart/form-data' }
				   }
				   let formData = new FormData();
				   formData.append('employee_id', this.employee_id);
				   formData.append('pay_slip_ref', this.pay_slip_ref);
				   formData.append('pay_slip_name', this.pay_slip_name);
				   formData.append('month', this.month);
				   formData.append('year', this.year);
				   formData.append('from_date', this.from_date);
				   formData.append('to_date', this.to_date);
				   formData.append('fiscal_year', this.fiscal_year);
				   if(this.adhoc_field!='')
				   formData.append('adhoc_field', this.adhoc_field);
				   if(this.adhoc_field_value!='')
				   formData.append('adhoc_field_value', this.adhoc_field_value);
				   axios.post(this.$api_url+'/payslip-action-vue', formData, config)
				   .then(function (response) {
                      //currentObj.getSalaryinfo();
                      currentObj.getSalaryDataFromDB('yes');
					  currentObj.success = response.data.success;
					  currentObj.fdata.id = response.data.payslip_id;
					  currentObj.adhoc_field_value="";
					  currentObj.adhoc_field="";
					  currentObj.hideAdhoc();
				  })
				  .catch(function (error) {
					  currentObj.output = error;
				  });
			  },

              emailTaxCards: function(taxcard)
              {
                  this.action_loader = true;
                  const config = {
					  headers: { 'content-type': 'multipart/form-data' }
				  }
                  let formData = new FormData();
                  formData.append('payslipids', taxcard);
                  formData.append('modification_flag', '4');

				  axios.post(this.$api_url+'/modifypayslips', formData, config)

				  .then(function (response) {
				    this.action_loader = false;

                    if(response.data.success)
                        this.$bvToast.toast(response.data.success, {
                                           title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });



				  }.bind(this));
              },

              get_decimal_settings: function()
              {
                  axios.get(this.$api_url+'/decimal-settings')

				  .then(function (response) {
				    this.decimal_setting = response.data;
				  }.bind(this));
              },

        getSalaryDataFromDB: function(is_taxcard)
        {
            this.payslip_loader = true;
              axios.get(this.$api_url+'/salary-slip-db/'+this.employee_id , {
                params: {
                  fiscal_year: this.fiscal_year,
								  payslip_id: this.fdata.id,
                  output_type: 'merge_report',
                  is_taxcard: is_taxcard,
								  search_query_by_id: '',
                }
            }).then(function(response){
              this.salaryheads = response.data.salary;
              this.slabs_and_values=response.data.slabsnvalues;
              this.taxinfo=response.data.tax;
              let max_inv_limit = 0;
              let invested_amount = 0;

              this.salaryheads.forEach(element => {
                    if(element.displayset == 'tax_allocation_method'){
                      this.tax_allocation_method = element.value;
                    }
              });

              for (let [key, value] of Object.entries(this.taxinfo))
              {
                if(value.head === 'Invested Amount'){
                    invested_amount = value.value;
                }
                if(value.head === 'Max Allow Inv Limit'){
                    max_inv_limit = value.value;
                }
              }
              if(parseFloat(max_inv_limit.replace(/,/g, '')) < parseFloat(invested_amount.replace(/,/g, '')))
                this.lower_of_amount = max_inv_limit;
              else
                this.lower_of_amount = invested_amount;

              if(parseFloat(this.lower_of_amount.replace(/,/g, '')) > 10000000)
                this.lower_of_amount = 10000000;

              this.setTaxData(response.data.tax);

              if( is_taxcard != 'update'){
                  this.payslip_loader = false;
              }



            }.bind(this));
        },
		  },
		  created: function(){
		     this.getPayslipInfo();
			 this.getFiscalyears();
			 this.get_decimal_settings();
		  }
	  }
  </script>
